export const filterTemplates = (templates, searchValue) => {
    if (!templates) return templates;
    return templates.filter((template) => {
        return template?.title?.toLowerCase().includes(searchValue?.toLowerCase());
    });
};
